

const getters = {
  // 动态生成 getter，支持多个 fieldcode
  ...(() => {
    const dynamicGetters = {};
    const fieldcodes = [
      'notes', 
      'team', 
      'school', 
      'name', 
      'declarecontent', 
      'prizepi',
      'projectneirong', 
      'teachertable', 
      'dutyperson', 
      'dutypersonphone',
      'dutypersonmajor',
      'teamper',
      'address',
      'introduce',
      'innovate',
      'activitytime',
      'activityweizi',
      'activityobject',
      'step',
      'risk',
      'target',
      'projectbubget'
    ]; // 根据需要添加所有 fieldcode

    fieldcodes.forEach(fieldcode => {
      dynamicGetters[fieldcode] = (state) => {
        if (Array.isArray(state.hintText)) {
          console.log(state.hintText,"123123");
          const item = state.hintText.find(item => item.fieldcode == fieldcode);
          console.log(item,"123123");
          return item || '';
        } else {
          // 兼容旧的对象格式
          return state.hintText[fieldcode]?.text || '';
        }
      };
    });
    return dynamicGetters;
  })()
};

export default getters;
